export const CRYPTOLOGY_CONTACT = {
  email: 'hola@inmueble.red',
  address: 'Calle Conde de la Monclova 378, 15073, San Isidro, Lima, Perú',
  legalName: 'CRYPTOLOGY S.A.C.',
  ruc: '20604970807',
  personalDataBank: {
    registrySystem:
      'SIPDP - Sistema Integrado de Protección de Datos Personales',
    denomination: 'PROSPECTO DE CLIENTES',
    bankCode: 'PN-2026-105',
    certificateNumber: 'INS-2026-3488',
    registrationDate: '11/06/2026',
    status: 'INSCRITO',
  },
} as const;
